/** @type {"use_scrolling_canvas_views"} */
export const SCROLLING_VIEWS_FLAG = "use_scrolling_canvas_views";
/** @type {"forms_design_app"} */
export const FORMS_FLAG = "forms_design_app";
